import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component, useEffect, useState }  from 'react';
import {Tab, Row, Col} from "react-bootstrap";
import { Spinner } from 'reactstrap';
import moment from 'moment';
import { sleep } from './AddBrandModal';
import { af } from 'date-fns/locale';

function AddAffiliateModal({isOpen, closeModal, user}) {
    const [selectedUser, setSelectedUser] = useState(user && user.user ? user.user : null)
    const [searchedUsers, setSearchededUsers] = useState([])
    const [cpa, setCPA] = useState(user && user.cpa ? user.cpa : null)
    const [cpc, setCPC] = useState(user && user.cpc ? user.cpc : null)
    const [slug, setSlug] = useState(user && user.slug ? user.slug : null)
    const [cpCreate, setCPCreate] = useState(user && user.cpCreate ? user.cpCreate : null)
    const [selectionID, setSelectionID] = useState(user && user.selectionID ? user.selectionID : null)
    const [shortDescription, setShortDescription] = useState(user && user.shortDescription ? user.shortDescription : null)
    const [description, setDescription] = useState(user && user.description ? user.description : null)
    const [showOnSelection, setShowOnSelection] = useState(user && user.showOnSelection ? user.showOnSelection : false)
    const [selectedImage, setSelectedImage] = useState(user && user.image ? user.image : null)
    const [order, setOrder] = useState(user && user.order ? user.order : "1000")
    const [loadingData, setLoadingData] = useState(true)
    const [loadingSubmit, setLoadingSubmit] = useState(false)

    const getAmbassadorApprovedUsers = () => {
        return fetch('https://back-api.therunningcollective.fr/ambassador-approved-front-users', {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            },
        })
        .then(res => res.json())
        .then(data => {
            // Trie par ordre alphabétique du firstName
            return data.sort((a, b) =>
                a.firstName.localeCompare(b.firstName)
            );
        })
        .catch(err => console.log(err));
    };


    useEffect(() => {
        getAmbassadorApprovedUsers().then(data => {
            setSearchededUsers(data);
        }).catch( err =>
            console.log(err)
        ).finally(() => { setLoadingData(false) });
    }, [])

    const handleClose = (selectedUser) => {
        setLoadingSubmit(true)
        let affiliate = {}
        affiliate.cpc = cpc
        affiliate.cpa = cpa
        affiliate.cpCreate = cpCreate
        affiliate.selectionID = selectionID
        affiliate.description = description
        affiliate.shortDescription = shortDescription
        affiliate.user = selectedUser
        affiliate.userID = selectedUser.id
        affiliate.slug = slug
        affiliate.image = selectedImage
        affiliate.showOnSelection = showOnSelection
        affiliate.order = order
        return fetch('https://back-api.therunningcollective.fr/affiliate', {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(affiliate)
        }).then(() => {
            setLoadingSubmit(false);
            window.location.reload();
        })
            .catch( err =>
                setLoadingSubmit(false)
            )
    }

    const uploadFirstImg = (e) => {
            const file = e.target.files[0]
            const fileName = e.target.files[0].name
            const reader = new FileReader()
    
            reader.readAsDataURL(file)
    
            reader.onload = () => {
                fetch('https://back-api.therunningcollective.fr/upload-file', {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        blob:reader.result,
                        fileName: "back-users/"+fileName
                    })}).then((res) =>
                res.json().then( result =>{
                    sleep(1000)
                    setSelectedImage(result.message);
                })
            )
                .catch( err =>
                    console.log(err)
                );
            }
        }


    return(
        <Modal
            show={isOpen}
            onHide={closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Ajouter un affilié</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Row>
                        <Col>
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    {
                                        loadingData ?
                                        <Row style={{marginTop: "30px", textAlign:"center"}}>
                                            <Col>
                                                <div style={{textAlign: 'center'}}>
                                                    <Spinner animation="border" role="status">
                                                        <span className="visually-hidden"></span>
                                                    </Spinner>
                                                </div>
                                            </Col>
                                        </Row>
                                        : searchedUsers && searchedUsers.length > 0 ?
                                        <>
                                            <Form.Group >
                                                <Form.Label>Liste des ambassadeurs trouvés : </Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    custom
                                                    defaultValue={selectedUser && selectedUser.email ? selectedUser.email : ""}
                                                    onChange={(e) => {
                                                    const email = e.target.value;
                                                    const selected = searchedUsers.find(u => u.email === email);
                                                    setSelectedUser(selected || null);
                                                    }}
                                                >
                                                    <option value="">Ajouter...</option>

                                                    {searchedUsers?.map(user => (
                                                    <option key={user.email} value={user.email}>
                                                        {user.firstName} {user.name} ({user.email})
                                                    </option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group> 
                                            <Form.Group >
                                                <Form.Label>Photo de profil : </Form.Label>
                                                <Form.File
                                                    id="custom-first-img-translate-html"
                                                    label="Ajouter un image"
                                                    data-browse="Ajouter"
                                                    onChange= {(e) => uploadFirstImg(e)}
                                                    custom
                                                />
                                                {selectedImage ?
                                                    <img className="imgToDisplay" alt="Couverture actuelle" src={selectedImage}/>
                                                    :
                                                    null
                                                }
                                            </Form.Group>
                                             <Form.Group >
                                                <Form.Label>Distance : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => setShortDescription(e.target.value)} defaultValue={shortDescription} placeholder="800m"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Description : </Form.Label>
                                                <Form.Control as="textarea" rows={4} onChange={(e) => {setDescription(e.target.value)}} defaultValue={description} placeholder="Pour avoir réalisé cette action"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Sélectionner la liste de produits à afficher : </Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    custom
                                                    defaultValue={selectionID ? selectionID : ""}
                                                    onChange={(e) => {
                                                        const id = e.target.value;
                                                        const selected = user?.selectionLinks.find(u => u.id === id);
                                                        setSelectionID(selected.id || null);
                                                    }}
                                                >
                                                    <option value="">Ajouter...</option>

                                                    {user?.selectionLinks?.sort((a, b) => b.createdDate.localeCompare(a.createdDate)).map(links => (
                                                    <option key={links.id} value={links.id}>
                                                        {moment(links.createdDate).format("DD/MM/YYYY - hh:mm")} ({links.products.length} produits)
                                                    </option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group> 
                                             <Form.Group >
                                                <Form.Label>Slug : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => setSlug(e.target.value)} defaultValue={slug} placeholder="antoine-provost"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Cout par clic : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => setCPC(e.target.value)} defaultValue={cpc} placeholder="0.1"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Cout par redirection : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => setCPA(e.target.value)} defaultValue={cpa} placeholder="0.4"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Cout par création de compte : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => setCPCreate(e.target.value)} defaultValue={cpCreate} placeholder="1"/>
                                            </Form.Group>
                                        </>
                                        : null
                                    }
                                    
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </Modal.Body>
            <Modal.Footer>
                {
                    loadingSubmit ?
                    <Row style={{textAlign:"center"}}>
                        <Col>
                            <div style={{textAlign: 'center'}}>
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden"></span>
                                </Spinner>
                            </div>
                        </Col>
                    </Row>
                    :
                    <>
                        <Button variant="secondary" type="cancel" onClick={closeModal}>
                            Annuler
                        </Button>
                        {
                            selectedUser ?
                                <Button variant="primary" type="submit" onClick={() => handleClose(selectedUser)}>
                                    Valider
                                </Button>
                                : <Button variant="primary" type="submit" disabled>
                                    Valider
                                </Button>

                        }
                    </>
                
            }
                
            </Modal.Footer>
        </Modal>
    )
}

export default AddAffiliateModal;

export function sliceIntoChunks(arr, chunkSize) {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
    }
    return res;
}